<script setup lang="ts">
import { setTag } from "@sentry/nuxt"

const { $identifyUser } = useNuxtApp()

const devText = import.meta.dev ? "[DEV] " : ""
useHead({
  bodyAttrs: {
    class: "relative min-h-svh w-full",
  },
  htmlAttrs: {
    class: "relative min-h-svh w-full",
  },
  titleTemplate: (titleChunk) => {
    return devText + (titleChunk ? `${titleChunk} – Moxso` : "Moxso")
  },
  link: [{ rel: "icon", type: "image/ico", href: "/favicon.ico" }],
  meta: [
    { name: "referrer", content: "no-referrer-when-downgrade" },
    { name: "robots", content: "noindex, nofollow" },
  ],
})

const { session, workspaceId, userRole, isImpersonating } = useAuth()

watch(
  [session, workspaceId, userRole, isImpersonating],
  () => {
    setTag("workspace_id", workspaceId.value)
    setTag("user_id", session.value?.user.id)
    setTag("is_impersonating", Boolean(isImpersonating.value))

    $identifyUser({
      userId: session.value?.user.id,
      workspaceId: workspaceId.value,
      userRole: userRole.value,
      isImpersonating: Boolean(isImpersonating.value),
    })
  },
  { immediate: true },
)
</script>
<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
